import type { ComponentProps } from 'react';

import LocationMap, { LocationMapModal } from './LocationMap';

type StoreLocatorProps = ComponentProps<typeof LocationMap>;

const StoreLocator = (props: StoreLocatorProps) => {
  return <LocationMap {...props} />;
};

export { LocationMapModal };
export default StoreLocator;
